import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import { Fragment, ReactNode, useState } from 'react';

export const GiftCap = ({ width = 100 }: { width?: number }) => (
  <svg
    width={width}
    viewBox="0 0 455 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M288.13 53.0681H259.878L279.854 33.1383L283.919 29.0764L279.854 25.0145L268.857 14.0268L264.791 9.93566L260.726 14.0268L240.75 33.9566V5.75684V0H234.988H219.429H213.667V5.75684V33.9566L193.721 14.0268L189.655 9.93566L185.59 14.0268L174.593 25.0145L170.528 29.0764L174.593 33.1383L194.539 53.0681H166.316H160.554V58.8249V74.3713V80.1281H166.316H194.539L174.593 100.058L170.528 104.12L174.593 108.182L185.59 119.169L189.655 123.261L193.721 119.169L213.667 99.2397V127.439V133.196H219.429H234.988H240.75V127.439V99.2397L260.726 119.169L264.762 123.261L268.857 119.169L279.854 108.182L283.919 104.12L279.854 100.058L259.878 80.1281H288.13H293.863V74.3713V58.8249V53.0681H288.13Z"
      fill="#F49D17"
    />
    <path
      d="M454.401 78.5798H0.0454102V155.523H454.401V78.5798Z"
      fill="#FFD008"
    />
    <path d="M247.068 78.5798H207.35V155.523H247.068V78.5798Z" fill="#F49D17" />
  </svg>
);

export const GiftBody = ({ width = 100 }: { width?: number }) => (
  <svg
    width={width}
    viewBox="0 0 455 275"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M454.401 0.917969H0.0458984V274.119H454.401V0.917969Z"
      fill="#FFD008"
    />
    <path
      d="M247.068 0.917969H207.35V274.119H247.068V0.917969Z"
      fill="#F49D17"
    />
  </svg>
);

export const JebsTicket = ({ width = 150 }: { width?: number | string }) => (
  <div className="w-fit m-auto drop-shadow-md ">
    <svg
      width={width}
      viewBox="0 0 321 248"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M285.924 73.7515C282.911 66.2706 284.754 58.0298 289.93 52.5068L274.429 13.9331C270.072 3.0915 257.729 -2.16855 246.879 2.1856L14.1002 95.61C3.24944 99.9641 -2.01505 112.296 2.34278 123.138L17.8438 161.711C25.4188 162.12 32.4381 166.796 35.4506 174.277C38.4631 181.758 36.6205 189.999 31.4437 195.522L46.9447 234.095C51.3026 244.937 63.6449 250.197 74.4956 245.843L307.274 152.389C318.125 148.035 323.389 135.703 319.031 124.862L303.53 86.288C295.955 85.8789 288.936 81.2033 285.924 73.7223V73.7515Z"
        fill="white"
      />
    </svg>
  </div>
);

export const RotateSnowFlower = ({
  left,
  top,
  right,
  bottom,
  width = 100,
  duration = 10,
  reverse = false,
}: {
  left?: string;
  top?: string;
  right?: string;
  bottom?: string;
  width?: number;
  duration?: number;
  reverse?: boolean;
}) => (
  <motion.div
    className={`absolute z-0`}
    initial={{ width: width, left, top, right, bottom }}
    animate={{ rotate: reverse ? -360 : 360 }}
    transition={{ repeat: Infinity, duration: duration, ease: 'linear' }}
  >
    <SnowFlower width={width} />
  </motion.div>
);

export const SnowFlower = ({
  width = 100,
  color = '#FF9B00',
  opacity = 0.2,
}: {
  width?: number;
  color?: string;
  opacity?: number;
}) => (
  <svg
    width={width}
    viewBox={`0 0 100 100`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={opacity}
      d="M90.6667 40.8047H72.7407L85.4568 28.0918C89.0865 24.4631 89.0865 18.5139 85.4568 14.8605C81.8272 11.2318 75.8765 11.2318 72.2222 14.8605L59.4321 27.6475V9.35571C59.4321 4.22118 55.2346 0 50.0741 0C44.9136 0 40.716 4.19649 40.716 9.35571V27.5241L27.8766 14.6877C24.2469 11.059 18.2963 11.059 14.642 14.6877C11.0123 18.3165 11.0123 24.2656 14.642 27.919L27.5062 40.78H9.35805C4.22224 40.78 0 44.9765 0 50.1358C0 55.2703 4.19755 59.4915 9.35805 59.4915H27.5308L14.6914 72.3278C11.0618 75.9566 11.0618 81.9057 14.6914 85.5591C18.321 89.1879 24.2716 89.1879 27.9259 85.5591L40.6667 72.8215V90.6443C40.6667 95.7788 44.8642 100 50.0247 100C55.1852 100 59.3828 95.8035 59.3828 90.6443V72.7228L72.0988 85.4357C75.7284 89.0644 81.679 89.0644 85.3333 85.4357C88.963 81.807 88.963 75.8578 85.3333 72.2044L72.6666 59.5408H90.642C95.7778 59.5408 100 55.3444 100 50.1851C100 45.0506 95.8024 40.8294 90.642 40.8294L90.6667 40.8047Z"
      fill={color}
    />
  </svg>
);

export const GiftBox = ({ width = 100 }: { width?: number }) => (
  <svg
    width={width}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M50 30V55H10V30" stroke="#667080" />
    <path d="M55 17.5H5V30H55V17.5Z" stroke="#667080" />
    <path d="M30 55V17.5" stroke="#667080" />
    <path
      d="M30 17.5H18.75C17.0924 17.5 15.5027 16.8415 14.3306 15.6694C13.1585 14.4973 12.5 12.9076 12.5 11.25C12.5 9.5924 13.1585 8.00269 14.3306 6.83058C15.5027 5.65848 17.0924 5 18.75 5C27.5 5 30 17.5 30 17.5Z"
      stroke="#667080"
    />
    <path
      d="M30 17.5H41.25C42.9076 17.5 44.4973 16.8415 45.6694 15.6694C46.8415 14.4973 47.5 12.9076 47.5 11.25C47.5 9.5924 46.8415 8.00269 45.6694 6.83058C44.4973 5.65848 42.9076 5 41.25 5C32.5 5 30 17.5 30 17.5Z"
      stroke="#667080"
    />
  </svg>
);

export const DownCircleArrow = ({
  width = 100,
  bgColor = '#FFD008',
}: {
  width?: number;
  bgColor?: string;
}) => (
  <svg
    width={width}
    viewBox="0 0 73 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.2825 72.5562C16.2463 72.5562 -9.40145e-05 56.3189 -9.31387e-05 36.2826C-9.22629e-05 16.2463 16.2463 -2.46138e-06 36.2825 -1.58557e-06C56.3188 -7.09758e-07 72.5562 16.2374 72.5562 36.2736C72.5561 56.3099 56.3188 72.5473 36.2825 72.5473"
      fill={bgColor}
    />
    <path
      d="M32.4916 61.2635C32.5696 61.3331 32.6562 61.3853 32.7342 61.4462C32.8122 61.4984 32.8815 61.5593 32.9595 61.6115C33.0461 61.6724 33.1328 61.7246 33.2281 61.7768C33.306 61.8203 33.384 61.8725 33.462 61.916C33.5486 61.9595 33.6353 62.003 33.7306 62.0465C33.8172 62.09 33.9039 62.1335 33.9992 62.1683C34.0858 62.2031 34.1638 62.2292 34.2504 62.264C34.3544 62.2988 34.4497 62.3423 34.5537 62.3684C34.6317 62.3945 34.7183 62.4119 34.7963 62.4293C34.9003 62.4554 35.0129 62.4902 35.1169 62.5076C35.2035 62.525 35.2901 62.5337 35.3768 62.5511C35.4808 62.5685 35.5847 62.5859 35.6887 62.5946C35.8187 62.6033 35.9486 62.612 36.0786 62.612C36.1479 62.612 36.2085 62.6207 36.2779 62.6207C36.3645 62.6207 36.4511 62.612 36.5378 62.612C36.6417 62.612 36.7544 62.612 36.8584 62.5946C36.9797 62.5859 37.1009 62.5598 37.2222 62.5424C37.2916 62.5337 37.3609 62.525 37.4302 62.5076C37.5601 62.4815 37.6814 62.4467 37.8027 62.4206C37.8634 62.4032 37.9327 62.3858 37.9934 62.3684C38.1147 62.3336 38.2273 62.2901 38.3399 62.2466C38.4092 62.2205 38.4785 62.2031 38.5479 62.1683C38.6518 62.1248 38.7558 62.0726 38.8598 62.0204C38.9377 61.9856 39.0071 61.9508 39.085 61.916C39.1803 61.8638 39.2756 61.8029 39.3623 61.7507C39.4403 61.7072 39.5096 61.6637 39.5876 61.6115C39.6829 61.5506 39.7695 61.481 39.8562 61.4114C39.9255 61.3592 39.9948 61.3157 40.0554 61.2635C40.1767 61.1678 40.2894 61.0634 40.3933 60.959C40.428 60.9329 40.4626 60.8981 40.4886 60.872L58.1895 43.0973C60.5202 40.7569 60.5202 36.9723 58.1895 34.6319C55.8588 32.2915 52.0899 32.2915 49.7593 34.6319L42.2388 42.1838L42.2388 14.978C42.2388 11.6719 39.5702 8.99219 36.2779 8.99219C32.9855 8.99219 30.3169 11.6719 30.3169 14.978L30.3169 42.1838L22.7964 34.6319C20.4658 32.2915 16.6969 32.2915 14.3662 34.6319C12.0355 36.9723 12.0355 40.7569 14.3662 43.0973L32.0671 60.872C32.1277 60.9329 32.1884 60.9851 32.249 61.0373C32.327 61.1156 32.4136 61.1939 32.5003 61.2635L32.4916 61.2635Z"
      fill="white"
    />
  </svg>
);

export const DiscountTicket = ({ width = 100 }: { width?: number }) => (
  <svg
    width={width}
    viewBox="0 0 431 187"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_610_1113)">
      <rect
        x="22"
        y="18"
        width="359.63"
        height="142.354"
        rx="21.4065"
        fill="white"
      />
      <rect
        x="22.5352"
        y="18.5352"
        width="358.56"
        height="141.283"
        rx="20.8714"
        stroke="#D5D5D5"
      />
    </g>
    <rect
      x="381.63"
      y="18"
      width="49.2351"
      height="142.354"
      rx="10.7033"
      fill="#FF4F00"
    />
    <path
      d="M150.798 111.544L175.774 89.5956C177.982 87.5774 179.7 85.8744 180.93 84.4869C182.191 83.0993 183.169 81.696 183.863 80.2769C184.557 78.8263 184.919 77.2653 184.951 75.594C184.919 73.7334 184.462 72.1093 183.579 70.7218C182.728 69.3027 181.545 68.2147 180.031 67.4579C178.549 66.701 176.846 66.3226 174.923 66.3226C171.958 66.3226 169.593 67.2056 167.827 68.9715C166.061 70.7375 165.178 73.1657 165.178 76.2562H149.852C149.852 71.7151 150.893 67.7417 152.974 64.3359C155.087 60.9301 158.035 58.3126 161.82 56.4836C165.635 54.6545 170.035 53.74 175.017 53.74C180.094 53.74 184.557 54.6072 188.404 56.3417C192.283 58.0446 195.279 60.457 197.391 63.579C199.504 66.701 200.561 70.296 200.561 74.3641C200.561 77.0761 200.009 79.6935 198.905 82.2164C197.833 84.7392 195.941 87.5458 193.229 90.6363C190.548 93.6952 186.748 97.3848 181.829 101.705L173.22 109.652V110.125H201.412V123.181H150.798V111.544ZM234.551 124.127C229.284 124.127 224.538 123.291 220.313 121.62C216.087 119.917 212.776 117.583 210.379 114.619C208.014 111.655 206.831 108.328 206.831 104.638C206.831 101.863 207.509 99.2769 208.865 96.8803C210.221 94.4836 212.066 92.4969 214.4 90.9201C216.765 89.3433 219.382 88.3342 222.252 87.8927V87.4197C219.761 86.9466 217.537 86.0006 215.582 84.5815C213.627 83.1309 212.098 81.3491 210.994 79.2363C209.922 77.0919 209.386 74.774 209.386 72.2827C209.386 68.7508 210.458 65.5815 212.602 62.7749C214.778 59.9682 217.774 57.7608 221.59 56.1525C225.437 54.5442 229.757 53.74 234.551 53.74C239.281 53.74 243.554 54.5442 247.37 56.1525C251.186 57.7608 254.181 59.984 256.357 62.8222C258.533 65.6288 259.621 68.7823 259.621 72.2827C259.621 74.774 259.054 77.0919 257.918 79.2363C256.815 81.3491 255.285 83.1309 253.33 84.5815C251.406 86.0006 249.215 86.9466 246.755 87.4197V87.8927C249.593 88.3342 252.179 89.3433 254.513 90.9201C256.878 92.4969 258.738 94.4836 260.094 96.8803C261.482 99.2769 262.176 101.863 262.176 104.638C262.176 108.328 260.977 111.655 258.581 114.619C256.215 117.583 252.936 119.917 248.742 121.62C244.547 123.291 239.817 124.127 234.551 124.127ZM234.551 112.206C236.632 112.206 238.477 111.812 240.085 111.024C241.725 110.235 242.986 109.132 243.869 107.713C244.784 106.294 245.241 104.701 245.241 102.935C245.241 101.169 244.768 99.5765 243.822 98.1574C242.908 96.7068 241.63 95.5873 239.991 94.7989C238.382 93.979 236.569 93.5691 234.551 93.5691C232.501 93.5691 230.64 93.979 228.969 94.7989C227.329 95.5873 226.036 96.7068 225.09 98.1574C224.176 99.5765 223.734 101.169 223.766 102.935C223.734 104.701 224.16 106.294 225.043 107.713C225.957 109.132 227.235 110.235 228.874 111.024C230.546 111.812 232.438 112.206 234.551 112.206ZM234.551 82.5002C236.317 82.5002 237.909 82.1375 239.328 81.4122C240.747 80.6869 241.851 79.6778 242.64 78.3848C243.428 77.0919 243.822 75.6255 243.822 73.9857C243.822 72.4089 243.428 70.9898 242.64 69.7284C241.851 68.4354 240.747 67.4421 239.328 66.7483C237.909 66.023 236.317 65.6603 234.551 65.6603C232.722 65.6603 231.098 66.023 229.679 66.7483C228.259 67.4421 227.156 68.4197 226.367 69.6811C225.579 70.9425 225.185 72.3774 225.185 73.9857C225.185 75.594 225.579 77.0603 226.367 78.3848C227.187 79.6778 228.307 80.6869 229.726 81.4122C231.145 82.1375 232.753 82.5002 234.551 82.5002Z"
      fill="#FF4F00"
    />
    <path
      d="M295.961 95.6266H300.209V99.6977H295.961V106.353H290.863V88.9005H295.961V95.6266ZM295.961 116.053H279.216V117.504H296.81V121.221H274.189V112.619H290.863V111.168H274.154V107.557H295.961V116.053ZM289.305 94.9894H270.047V91.1661H277.127V88.7235H282.225V91.1661H289.305V94.9894ZM279.676 95.5912C281.305 95.5912 282.727 95.8096 283.942 96.2462C285.157 96.671 286.096 97.2846 286.756 98.087C287.417 98.8894 287.748 99.8276 287.748 100.901C287.748 101.999 287.417 102.943 286.756 103.733C286.096 104.524 285.157 105.132 283.942 105.557C282.738 105.981 281.316 106.2 279.676 106.212C278.048 106.2 276.62 105.981 275.393 105.557C274.165 105.132 273.216 104.524 272.543 103.733C271.882 102.943 271.558 101.999 271.569 100.901C271.558 99.8276 271.888 98.8894 272.561 98.087C273.233 97.2846 274.183 96.671 275.41 96.2462C276.638 95.8096 278.06 95.5912 279.676 95.5912ZM279.676 99.1313C278.661 99.1313 277.883 99.2788 277.34 99.5738C276.797 99.8689 276.526 100.311 276.526 100.901C276.526 101.48 276.791 101.904 277.322 102.176C277.853 102.435 278.638 102.577 279.676 102.601C280.726 102.577 281.523 102.435 282.066 102.176C282.62 101.904 282.898 101.48 282.898 100.901C282.898 100.311 282.614 99.8689 282.048 99.5738C281.493 99.2788 280.703 99.1313 279.676 99.1313ZM327.619 112.159H322.521V88.9359H327.619V112.159ZM328.433 120.867H305.6V109.822H310.768V116.796H328.433V120.867ZM309.741 90.9537C311.405 90.9537 312.922 91.3136 314.29 92.0335C315.659 92.7415 316.739 93.7268 317.53 94.9894C318.332 96.2403 318.733 97.6445 318.733 99.2021C318.733 100.795 318.332 102.229 317.53 103.503C316.739 104.766 315.659 105.751 314.29 106.459C312.922 107.167 311.405 107.521 309.741 107.521C308.078 107.521 306.555 107.167 305.175 106.459C303.806 105.751 302.72 104.766 301.918 103.503C301.127 102.229 300.738 100.795 300.75 99.2021C300.738 97.6445 301.127 96.2403 301.918 94.9894C302.72 93.7268 303.806 92.7415 305.175 92.0335C306.555 91.3136 308.078 90.9537 309.741 90.9537ZM309.741 95.3788C308.974 95.367 308.284 95.5145 307.671 95.8214C307.057 96.1164 306.573 96.5589 306.219 97.1489C305.877 97.7271 305.706 98.4115 305.706 99.2021C305.706 100.028 305.877 100.736 306.219 101.326C306.573 101.904 307.051 102.347 307.653 102.654C308.266 102.949 308.963 103.096 309.741 103.096C310.485 103.096 311.152 102.949 311.742 102.654C312.343 102.347 312.815 101.904 313.158 101.326C313.5 100.736 313.671 100.028 313.671 99.2021C313.671 98.4115 313.5 97.7271 313.158 97.1489C312.815 96.5589 312.343 96.1164 311.742 95.8214C311.14 95.5145 310.473 95.367 309.741 95.3788Z"
      fill="#FF4F00"
    />
    <path
      d="M295.961 95.6266H300.209V99.6977H295.961V106.353H290.863V88.9005H295.961V95.6266ZM295.961 116.053H279.216V117.504H296.81V121.221H274.189V112.619H290.863V111.168H274.154V107.557H295.961V116.053ZM289.305 94.9894H270.047V91.1661H277.127V88.7235H282.225V91.1661H289.305V94.9894ZM279.676 95.5912C281.305 95.5912 282.727 95.8096 283.942 96.2462C285.157 96.671 286.096 97.2846 286.756 98.087C287.417 98.8894 287.748 99.8276 287.748 100.901C287.748 101.999 287.417 102.943 286.756 103.733C286.096 104.524 285.157 105.132 283.942 105.557C282.738 105.981 281.316 106.2 279.676 106.212C278.048 106.2 276.62 105.981 275.393 105.557C274.165 105.132 273.216 104.524 272.543 103.733C271.882 102.943 271.558 101.999 271.569 100.901C271.558 99.8276 271.888 98.8894 272.561 98.087C273.233 97.2846 274.183 96.671 275.41 96.2462C276.638 95.8096 278.06 95.5912 279.676 95.5912ZM279.676 99.1313C278.661 99.1313 277.883 99.2788 277.34 99.5738C276.797 99.8689 276.526 100.311 276.526 100.901C276.526 101.48 276.791 101.904 277.322 102.176C277.853 102.435 278.638 102.577 279.676 102.601C280.726 102.577 281.523 102.435 282.066 102.176C282.62 101.904 282.898 101.48 282.898 100.901C282.898 100.311 282.614 99.8689 282.048 99.5738C281.493 99.2788 280.703 99.1313 279.676 99.1313ZM327.619 112.159H322.521V88.9359H327.619V112.159ZM328.433 120.867H305.6V109.822H310.768V116.796H328.433V120.867ZM309.741 90.9537C311.405 90.9537 312.922 91.3136 314.29 92.0335C315.659 92.7415 316.739 93.7268 317.53 94.9894C318.332 96.2403 318.733 97.6445 318.733 99.2021C318.733 100.795 318.332 102.229 317.53 103.503C316.739 104.766 315.659 105.751 314.29 106.459C312.922 107.167 311.405 107.521 309.741 107.521C308.078 107.521 306.555 107.167 305.175 106.459C303.806 105.751 302.72 104.766 301.918 103.503C301.127 102.229 300.738 100.795 300.75 99.2021C300.738 97.6445 301.127 96.2403 301.918 94.9894C302.72 93.7268 303.806 92.7415 305.175 92.0335C306.555 91.3136 308.078 90.9537 309.741 90.9537ZM309.741 95.3788C308.974 95.367 308.284 95.5145 307.671 95.8214C307.057 96.1164 306.573 96.5589 306.219 97.1489C305.877 97.7271 305.706 98.4115 305.706 99.2021C305.706 100.028 305.877 100.736 306.219 101.326C306.573 101.904 307.051 102.347 307.653 102.654C308.266 102.949 308.963 103.096 309.741 103.096C310.485 103.096 311.152 102.949 311.742 102.654C312.343 102.347 312.815 101.904 313.158 101.326C313.5 100.736 313.671 100.028 313.671 99.2021C313.671 98.4115 313.5 97.7271 313.158 97.1489C312.815 96.5589 312.343 96.1164 311.742 95.8214C311.14 95.5145 310.473 95.367 309.741 95.3788Z"
      fill="#FF4F00"
    />
    <path
      d="M92.343 111.15C95.0217 110.985 97.4997 110.731 99.7772 110.389L100.167 114.106C97.0159 114.72 93.8004 115.115 90.5199 115.292C87.2512 115.469 83.6816 115.557 79.8111 115.557L79.2447 111.486C82.2656 111.486 84.9442 111.451 87.2807 111.38V106.601H92.343V111.15ZM98.786 96.6887H92.4669C92.6557 98.2227 93.3578 99.5974 94.5733 100.813C95.7887 102.028 97.5469 102.907 99.848 103.45L97.5469 107.344C95.7297 106.908 94.178 106.223 92.8917 105.291C91.6055 104.359 90.5789 103.238 89.8119 101.928C89.0802 103.309 88.0772 104.489 86.8028 105.468C85.5283 106.436 83.9766 107.144 82.1476 107.592L79.7757 103.769C82.0886 103.179 83.8468 102.253 85.0504 100.99C86.2541 99.7272 86.9444 98.2935 87.1214 96.6887H80.8731V92.6176H87.2807V89.2191H92.343V92.6176H98.786V96.6887ZM106.574 121.469H101.512V88.9005H106.574V121.469ZM137.524 121.398H132.71V105.326H130.09V119.841H125.453V89.3961H130.09V101.291H132.71V88.9005H137.524V121.398ZM122.267 96.6887H115.293V109.982C116.839 109.958 118.278 109.893 119.612 109.787C120.945 109.669 122.302 109.492 123.683 109.256L124.037 113.362C122.196 113.716 120.396 113.952 118.638 114.071C116.88 114.189 114.832 114.248 112.496 114.248H110.16V92.6176H122.267V96.6887Z"
      fill="#FF4F00"
    />
    <path
      d="M278.219 69.0784C276.921 69.0784 275.812 68.7834 274.891 68.1934C273.971 67.6034 273.274 66.7774 272.802 65.7154C272.33 64.6533 272.094 63.4261 272.094 62.0337C272.094 60.6294 272.336 59.3963 272.82 58.3343C273.304 57.2604 274.006 56.4285 274.927 55.8385C275.847 55.2485 276.944 54.9535 278.219 54.9535C279.54 54.9535 280.661 55.2485 281.582 55.8385C282.502 56.4285 283.199 57.2545 283.671 58.3166C284.154 59.3786 284.402 60.6176 284.414 62.0337C284.402 63.4497 284.154 64.6887 283.671 65.7508C283.187 66.801 282.479 67.6211 281.546 68.2111C280.626 68.7893 279.517 69.0784 278.219 69.0784ZM278.219 65.6092C278.95 65.6092 279.505 65.2905 279.883 64.6533C280.26 64.0161 280.449 63.1429 280.449 62.0337C280.449 60.9008 280.266 60.0158 279.9 59.3786C279.535 58.7296 278.974 58.411 278.219 58.4228C277.534 58.4228 277.003 58.7591 276.626 59.4317C276.248 60.0925 276.059 60.9598 276.059 62.0337C276.059 63.1311 276.248 64.0043 276.626 64.6533C277.003 65.2905 277.534 65.6092 278.219 65.6092ZM296.096 82.637C294.786 82.6252 293.671 82.3243 292.751 81.7343C291.83 81.1442 291.134 80.3182 290.662 79.2562C290.19 78.1942 289.96 76.961 289.972 75.5568C289.96 74.1644 290.196 72.9371 290.68 71.8751C291.164 70.8013 291.866 69.9694 292.786 69.3793C293.718 68.7775 294.822 68.4766 296.096 68.4766C297.418 68.4766 298.539 68.7716 299.459 69.3616C300.38 69.9517 301.076 70.7836 301.548 71.8574C302.02 72.9194 302.256 74.1526 302.256 75.5568C302.256 76.961 302.014 78.1942 301.53 79.2562C301.058 80.3182 300.356 81.1442 299.424 81.7343C298.504 82.3243 297.394 82.6252 296.096 82.637ZM296.096 79.1323C296.816 79.1323 297.359 78.8196 297.725 78.1942C298.102 77.557 298.303 76.6778 298.327 75.5568C298.303 74.424 298.108 73.539 297.742 72.9017C297.377 72.2645 296.828 71.9459 296.096 71.9459C295.388 71.9459 294.845 72.2763 294.468 72.9371C294.09 73.598 293.901 74.4712 293.901 75.5568C293.901 76.6424 294.096 77.5098 294.486 78.1588C294.875 78.8078 295.412 79.1323 296.096 79.1323ZM293.76 55.9801H298.079L280.449 81.6104H276.13L293.76 55.9801Z"
      fill="#FF4F00"
    />
    <path
      d="M404.676 118.324L404.676 111.333L406.139 111.333L406.139 116.63L409.511 116.63L409.511 111.702L410.959 111.702L410.959 116.63L414.362 116.63L414.362 111.271L415.825 111.271L415.825 118.324L404.676 118.324ZM413.746 102.269L413.746 102.146L404.676 99.0503L404.676 97.2176L415.825 101.237L415.825 103.193L404.676 107.197L404.676 105.364L413.746 102.269ZM404.676 92.897L404.676 85.9053L406.139 85.9053L406.139 91.203L409.511 91.203L409.511 86.2749L410.959 86.2749L410.959 91.203L414.362 91.203L414.362 85.8437L415.825 85.8437L415.825 92.897L404.676 92.897ZM415.825 71.9288L415.825 73.4842L407.679 79.1361L407.679 79.2285L415.825 79.2285L415.825 80.9225L404.676 80.9225L404.676 79.3517L412.838 73.6998L412.838 73.592L404.676 73.592L404.676 71.9288L415.825 71.9288ZM404.676 67.3002L404.676 58.6607L406.139 58.6607L406.139 62.1257L415.825 62.1257L415.825 63.8197L406.139 63.8197L406.139 67.3002L404.676 67.3002Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_610_1113"
        x="0.593456"
        y="0.874765"
        width="402.443"
        height="185.167"
        filterUnits="userSpaceOnUse"
      >
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.28131" />
        <feGaussianBlur stdDeviation="10.7033" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_610_1113"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_610_1113"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const OrangeCloud = ({ width = 'full' }: { width?: string }) => (
  <svg
    className={`w-${width}`}
    // width={width}
    viewBox="0 0 1000 260"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2388.59 278.433C2388.59 278.356 2388.61 278.28 2388.62 278.203C2394.96 226.613 2345.95 180.823 2279.14 175.925C2218.21 171.461 2163.52 202.564 2149.57 247.22C2129.15 234.033 2103.54 225.301 2075.04 223.214C2024.44 219.499 1977.69 237.636 1950.42 267.614H1816.95C1799.58 252.493 1775.04 242.219 1746.94 240.158C1742.81 239.859 1738.72 239.749 1734.68 239.8C1739.35 224.082 1735.93 206.976 1723.33 192.545C1701.33 167.338 1659 159.041 1624.56 171.896C1611.37 140.282 1574.89 116.148 1529.35 112.817C1473.11 108.694 1422.7 137.718 1410.57 179.171C1401.01 176.155 1390.74 174.153 1379.95 173.361C1320.74 169.016 1268.17 202.572 1262.55 248.302C1261.95 253.14 1261.82 259.189 1262.13 266.115C1261.14 265.936 1260.13 265.765 1259.13 265.612C1250.83 252.672 1235.22 242.867 1216.06 239.689C1203.61 202.555 1162.21 173.642 1109.9 169.8C1103.67 169.34 1097.51 169.263 1091.45 169.519C1090.22 136.432 1066.7 104.758 1026.2 88.0101C967.006 63.5354 893.57 80.0535 860.487 124.803C841.425 110.713 816.318 101.291 788 99.2125C727.063 94.7486 672.38 125.851 658.426 170.507C638.006 157.32 612.392 148.588 583.898 146.501C519.695 141.79 461.67 172.253 441.802 217.446C428.521 203.152 407.616 193.193 383.16 191.404C365.565 190.118 348.764 193.253 334.556 199.608C317.247 179.793 289.018 165.881 255.792 163.445C251.666 163.138 247.573 163.036 243.536 163.087C248.202 147.37 244.782 130.264 232.195 115.833C210.199 90.6254 167.871 82.328 133.432 95.183C120.238 63.5694 83.7462 39.4439 38.2197 36.1045C-18.0182 31.9814 -68.4316 61.0052 -80.5551 102.458C-90.1083 99.4425 -100.378 97.4406 -111.167 96.6483C-170.384 92.3037 -222.948 125.86 -228.574 171.589C-229.17 176.428 -229.302 182.476 -228.993 189.402C-229.986 189.223 -230.99 189.053 -231.994 188.908C-240.3 175.968 -255.899 166.162 -275.06 162.985C-287.515 125.851 -328.915 96.9379 -381.226 93.1044C-387.448 92.6444 -393.614 92.5592 -399.671 92.8233C-400.906 59.7359 -424.425 28.0627 -464.921 11.3145C-525.164 -13.5606 -600.1 3.94569 -632.333 50.4418C-664.567 96.9294 -641.898 154.798 -581.699 179.69C-561.027 188.235 -538.622 191.787 -516.813 190.876C-523.255 212.343 -537.1 244.494 -539.493 267.614H-622.229V622H2012.06V437.796C2026.47 434.499 2039.53 432.293 2049.24 433.008C2078.33 435.138 2131.81 448.095 2176.44 452.5C2186.4 475.415 2213.02 492.845 2246.19 495.273C2291.11 498.57 2330.99 473.115 2335.26 438.426C2337.65 418.91 2328.27 400.619 2311.6 387.773C2317.62 389.375 2323.96 390.473 2330.57 390.959C2375.49 394.256 2415.37 368.801 2419.63 334.112C2422.36 311.878 2409.79 291.262 2388.59 278.441V278.433Z"
      fill="#EB5D1A"
    />
  </svg>
);

export const DoubleQuote = ({
  color = 'white',
  width,
}: {
  color?: string;
  width: number;
}) => (
  <svg
    width={width}
    viewBox="0 0 57 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54.6374 21.6263C53.1004 19.6066 51.2502 18.0453 49.1011 16.8994C45.7139 15.1519 44.0771 13.032 44.1768 10.554C44.2622 8.4484 45.7138 6.1566 48.5461 3.67859C49.4142 2.91943 49.4854 1.57299 48.7168 0.699242C48.0337 -0.0742413 46.9093 -0.217479 46.0412 0.326825C40.0494 4.02236 35.6374 8.17625 32.8052 12.8028C30.1438 17.1286 28.6352 21.3971 28.2794 25.6083C27.8951 24.0756 27.2974 22.7435 26.4434 21.6406C24.9064 19.6209 23.0562 18.0597 20.9071 16.9137C17.5199 15.1662 15.8831 13.0463 15.9827 10.5683C16.0681 8.46273 17.5198 6.17092 20.352 3.69291C21.2202 2.93375 21.2914 1.58732 20.5228 0.713566C19.8397 -0.0599172 18.7153 -0.203155 17.8472 0.341148C11.8554 4.03668 7.44343 8.19057 4.61122 12.8172C1.53707 17.8305 0 22.7578 0 27.5993C0 33.071 1.3805 37.1676 4.15578 39.9034C6.93106 42.6392 10.3611 44 14.4599 44C16.5094 44 18.4023 43.6419 20.1528 42.9114C21.8891 42.1952 23.412 41.1782 24.6929 39.8891C25.9738 38.5999 26.97 37.0816 27.6959 35.3198C28.1228 34.2885 28.4075 33.2142 28.5925 32.1113C29.176 35.3771 30.4285 37.9697 32.3783 39.8891C35.1536 42.6249 38.5835 43.9857 42.6824 43.9857C44.7318 43.9857 46.6247 43.6276 48.3753 42.8971C50.1116 42.1809 51.6345 41.1639 52.9154 39.8748C54.1963 38.5856 55.1925 37.0673 55.9183 35.3055C56.6299 33.558 57 31.6959 57 29.7335C57 26.3245 56.2315 23.6173 54.6944 21.6119L54.6374 21.6263Z"
      fill={color}
    />
  </svg>
);

export const SpeechBubble = ({
  textArea,
  src,
  direction = 'left',
}: {
  textArea: React.ReactNode;
  src: string;
  direction?: 'left' | 'right';
}) => {
  return (
    <motion.div
      className="flex gap-3 items-center"
      initial={{ y: -20, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ type: 'spring', duration: 1 }}
    >
      {direction === 'left' && <img src={src} className="w-20" />}

      <div className="relative flex-1 p-4 bg-white rounded-lg shadow-md mx-2.5">
        {textArea}
        {direction === 'left' ? (
          <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-full w-0 h-0 border-t-[7px] border-t-transparent border-b-[7px] border-b-transparent border-r-[10px] border-r-white"></div>
        ) : (
          <div className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-full w-0 h-0 border-t-[7px] border-t-transparent border-b-[7px] border-b-transparent border-l-[10px] border-l-white"></div>
        )}
      </div>
      {direction === 'right' && <img src={src} className="w-20" />}
    </motion.div>
  );
};

export const IconCard = ({
  src,
  textArea,
}: {
  src: string;
  textArea: ReactNode;
}) => (
  <div className="grid grid-row-2 bg-white rounded-lg p-2">
    <img src={src} alt="icon3" className="h-[60px] m-auto" />
    <div className="border-t border-orange5 text-center pt-3 font-bold">
      {textArea}
    </div>
  </div>
);

// 아코디언1
export const AccordionColor = ({
  src,
  textArea,
  color,
  children,
}: {
  src?: string;
  textArea: ReactNode;
  color: string;
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div
        className="group relative flex w-full rounded-lg shadow-md p-4 text-white cursor-pointer"
        style={{ backgroundColor: color, paddingLeft: src && '96px' }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {src && (
          <img
            src={src}
            className="absolute left-4 bottom-4 w-[70px] transition-transform duration-300 transform group-hover:scale-110"
          />
        )}
        <div className="flex-1 text-lg md:text-xl">{textArea}</div>
        <div
          className="flex w-10 items-center justify-center"
          onClick={() => setIsOpen(!isOpen)}
        >
          <ChevronDownIcon
            className={`w-6 h-6 transform  ${
              isOpen ? 'rotate-180' : 'rotate-0'
            }`}
          />
        </div>
      </div>

      <motion.div
        style={{ overflow: 'hidden', transformOrigin: 'top' }}
        initial={{ height: 0 }}
        animate={isOpen ? { height: 'auto' } : {}}
      >
        {children}
      </motion.div>
    </div>
  );
};

export const PlusIcon = ({
  width = 23,
  color = 'white',
}: {
  width?: number;
  color?: string;
}) => (
  <svg
    width={width}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5102 8.31019H14.7202V1.6002C14.7202 0.830196 14.0902 0.200195 13.3202 0.200195H9.71019C8.9402 0.200195 8.31019 0.830196 8.31019 1.6002V8.31019H1.5202C0.790196 8.31019 0.200195 8.90019 0.200195 9.63019V13.3902C0.200195 14.1202 0.790196 14.7102 1.5202 14.7102H8.31019V21.4202C8.31019 22.1902 8.9402 22.8202 9.71019 22.8202H13.3202C14.0902 22.8202 14.7202 22.1902 14.7202 21.4202V14.7102H21.5102C22.2402 14.7102 22.8302 14.1202 22.8302 13.3902V9.63019C22.8302 8.90019 22.2402 8.31019 21.5102 8.31019Z"
      fill={color}
    />
  </svg>
);

export const DiamondIcon = ({
  width = 100,
  color = 'white',
}: {
  width?: number;
  color?: string;
}) => (
  <svg
    width={width}
    viewBox="0 0 355 356"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M353.114 177.127C272.53 147.946 218.165 94.3312 187.825 2.04351C186.948 -0.681171 183.09 -0.681171 182.125 2.04351C150.996 94.3312 96.5431 148.473 2.10448 177.039C-0.701494 177.918 -0.701494 181.873 2.10448 182.752C98.0338 211.932 150.032 268.272 182.651 354.055C183.616 356.692 187.386 356.604 188.263 354.055C218.515 267.217 270.689 213.075 353.027 182.927C355.658 181.961 355.658 178.269 353.027 177.302L353.114 177.127Z"
      fill={color}
    />
  </svg>
);

export const SnowmanIcon = ({
  width = 100,
  color = 'white',
}: {
  width?: number;
  color?: string;
}) => (
  <svg
    width={width}
    viewBox="0 0 369 376"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M247.342 132.683C245.808 132.683 244.274 132.683 242.741 132.779C243.028 129.136 243.316 125.397 243.316 121.658C243.316 54.4539 188.862 0 121.658 0C54.4537 0 0 54.4539 0 121.658C0 188.863 54.4537 243.317 121.658 243.317C123.192 243.317 124.726 243.317 126.259 243.221C125.972 246.864 125.684 250.603 125.684 254.342C125.684 321.546 180.138 376 247.342 376C314.546 376 369 321.546 369 254.342C369 187.137 314.546 132.683 247.342 132.683Z"
      fill={color}
    />
  </svg>
);

export const PackmanIcon = ({
  width = 100,
  color = 'white',
}: {
  width?: number;
  color?: string;
}) => (
  <svg
    width={width}
    viewBox="100 96 127 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M185.041 164.331C184.873 164.197 184.704 164.062 184.603 163.895C183.963 162.987 184.166 161.744 185.041 161.106L225.117 131.98C225.925 131.375 226.161 130.266 225.655 129.393C213.498 108.732 191.473 96 167.529 96C130.552 96 100.512 125.933 100.007 163.021C99.5018 198.497 126.612 228.766 161.737 231.755C188.712 234.04 213.97 220.165 226.767 196.716C227.238 195.843 226.969 194.768 226.194 194.197L185.075 164.298L185.041 164.331Z"
        fill={color}
      />
    </g>
  </svg>
);

export const KIDS = () => <span className="text-[#ff4f00]">KIDS</span>;
export const BASIC = () => <span className="text-[#ff9b00]">BASIC</span>;
export const ADVANCED = () => <span className="text-[#309c5b]">ADVANCED</span>;

export const GradientButton = ({ text }: { text: string }) => (
  <div
    className="flex justify-center items-center py-1 text-xl tracking-tighter leading-10 text-white rounded-xl max-md:px-5 max-md:mt-10 max-md:mr-1 max-md:max-w-full hover:opacity-90 cursor-pointer"
    style={{
      background: 'linear-gradient(90deg, #5E6EFF 0%, #21C1FF 100%)',
    }}
  >
    <div className="flex gap-3 items-center">
      <div className="font-bold">{text}</div>
      <ChevronDownIcon className="w-6 h-6 rotate-[-90deg]" />
    </div>
  </div>
);

// 빵 아이콘
export const BreadIcon = ({
  width = 100,
  color = 'white',
  opacity = 0.2,
}: {
  width?: number;
  color?: string;
  opacity?: number;
}) => (
  <svg
    width={width}
    viewBox="0 0 383 355"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g className="mix-blend-mode:hard-light" opacity={opacity}>
      <path
        d="M260.543 0.110486C218.806 0.110486 181.915 21.2138 159.89 53.4765C137.865 21.2138 100.974 0.110486 59.2371 0.110486C-8.26858 0.110486 -63 55.3548 -63 123.416V328.704C-63 343.178 -51.3268 355 -36.9006 355H356.901C371.327 355 383 343.288 383 328.704V123.305C383 55.2443 328.269 0 260.763 0L260.543 0.110486Z"
        fill={color}
      />
    </g>
  </svg>
);

export const CheckIcon = ({
  width,
  color = '#333333',
}: {
  width: number;
  color?: string;
}) => (
  <svg
    width={width}
    viewBox="0 0 60 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M29.8 0.679688C13.3423 0.679688 0 14.022 0 30.4797C0 46.9374 13.3423 60.2797 29.8 60.2797C46.2577 60.2797 59.6 46.9374 59.6 30.4797C59.6 14.022 46.2577 0.679688 29.8 0.679688ZM42.7169 25.4408C42.9548 25.1689 43.1359 24.8522 43.2495 24.5093C43.3632 24.1664 43.4071 23.8043 43.3787 23.4441C43.3503 23.084 43.2502 22.7332 43.0842 22.4124C42.9183 22.0915 42.6898 21.8071 42.4123 21.5758C42.1348 21.3446 41.8138 21.1712 41.4683 21.0658C41.1228 20.9604 40.7597 20.9252 40.4004 20.9622C40.041 20.9992 39.6927 21.1077 39.3759 21.2813C39.0592 21.4549 38.7803 21.6902 38.5558 21.9731L26.9067 35.9493L20.879 29.9189C20.368 29.4254 19.6837 29.1524 18.9734 29.1585C18.2631 29.1647 17.5836 29.4496 17.0813 29.9519C16.579 30.4542 16.2941 31.1337 16.2879 31.844C16.2818 32.5543 16.5548 33.2386 17.0483 33.7496L25.1756 41.8768C25.4418 42.1429 25.7605 42.3505 26.1113 42.4865C26.4622 42.6226 26.8376 42.684 27.2135 42.6669C27.5895 42.6499 27.9578 42.5546 28.2949 42.3874C28.632 42.2201 28.9305 41.9844 29.1715 41.6953L42.7169 25.4408Z"
      fill={color}
    />
  </svg>
);

export const Arrcodian = ({
  body,
  children,
}: {
  body: ReactNode;
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <motion.div
      className="bg-white rounded-lg cursor-pointer shadow-xl group"
      onClick={() => setIsOpen((open) => !open)}
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
    >
      <div className="flex justify-between items-center p-5 rounded-lg group-hover:bg-gray3">
        {body}
        <ChevronDownIcon
          className={`w-10 h-10 transform text-gray6 transition-transform duration-300 ease-in-out ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </div>

      <motion.div
        style={{ overflow: 'hidden', transformOrigin: 'top' }}
        initial={{ height: 0 }}
        animate={isOpen ? { height: 'auto' } : {}}
      >
        {children}
      </motion.div>
    </motion.div>
  );
};

export const TextCheckList = ({
  textArr,
  textSize,
}: {
  textArr: ReactNode[];
  textSize?: string;
}) => (
  <div className="flex flex-col gap-3 w-full min-w-full bg-gray2 rounded-lg mt-5 p-5">
    {/* <div className="flex flex-col gap-3 bg-gray2 rounded-lg mt-5 p-5 m-5"> */}
    {textArr.map((text, index) => (
      <motion.div
        key={index}
        className={`flex gap-2 items-start ${textSize || 'text-base'}`}
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ delay: index * 0.2 }}
      >
        <CheckIcon width={20} color="#9c9c9c" />
        <div className="flex-1">{text}</div>
      </motion.div>
    ))}
  </div>
);

export const NumberingText = ({
  number,
  text,
}: {
  number: number;
  text: string;
}) => (
  <div className="relative text-white bg-[#1a3f2d] ml-5 pl-6 pr-3 py-1 font-bold text-base rounded-r-full w-fit">
    <span className="absolute w-10 aspect-square leading-10 text-2xl left-0 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#235f42] text-center rounded-full">
      {number}
    </span>

    {text}
  </div>
);

export const HeadBox = ({
  head,
  children,
}: {
  head: ReactNode;
  children: ReactNode;
}) => (
  <div className="relative bg-white rounded-lg shadow-card mt-5">
    <div className="absolute top-0 left-1/2 transform -translate-y-1/2 -translate-x-1/2">
      {head}
    </div>
    <div>{children}</div>
  </div>
);

export const BigCheckIcon = ({ width }: { width: number }) => (
  <svg
    width={width}
    viewBox="0 0 56 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.903 40.4313C21.1323 40.4313 19.43 39.7298 18.181 38.4723L1.94504 22.1765C-0.655458 19.5674 -0.646906 15.3416 1.96215 12.7411C4.5712 10.1406 8.79701 10.1492 11.3975 12.7582L22.8602 24.2551L44.5539 2.01404C47.1287 -0.620672 51.3545 -0.680555 53.9892 1.89428C56.6239 4.46912 56.6753 8.68637 54.109 11.3296L27.6934 38.4125C26.4445 39.6956 24.7422 40.4142 22.9543 40.4227H22.9201L22.903 40.4313Z"
      fill="#6A62E3"
    />
  </svg>
);

export const PurchaseButton = ({
  link,
  children,
}: {
  link?: string;
  children: ReactNode;
}) => (
  <a href={link} target="_blank">
    <div
      className={`w-full h-auto bg-gradient-to-b from-[#5766e2] to-[#9457e2] rounded-lg ${
        link && 'hover:to-[#6b3fa3]'
      }`}
    >
      {children}
    </div>
  </a>
);

export const PurchaseBox = ({
  head,
  textArr,
  button,
  link,
}: {
  head: ReactNode;
  textArr: ReactNode[];
  button: ReactNode;
  link?: string;
}) => (
  <HeadBox
    head={
      <div className="w-fit px-9 py-1 font-bold bg-black text-white rounded-full">
        {head}
      </div>
    }
  >
    <div className="flex flex-col gap-5 p-5 font-semibold pt-8">
      {textArr.map((text, index) => (
        <div className="flex gap-3 items-center" key={index}>
          <BigCheckIcon width={24} />
          <div>{text}</div>
        </div>
      ))}

      <PurchaseButton link={link}>
        <div className="w-full text-center py-3 text-white font-extrabold text-lg">
          {button}
        </div>
      </PurchaseButton>
    </div>
  </HeadBox>
);

export const GrayNumList = ({ textArr }: { textArr: ReactNode[] }) => (
  <div className="bg-gray1 rounded-lg px-5">
    {textArr.map((text, i) => (
      <div
        key={i}
        className={`flex gap-3 py-7 px-1 text-[#464009] ${
          i !== 0 && 'border-t border-gray4'
        }`}
      >
        <div className="h-6 aspect-square leading-6 font-bold text-center bg-black text-white rounded-full">
          {i + 1}
        </div>
        <div>{text}</div>
      </div>
    ))}
  </div>
);

export const AsteriskLi = ({ children }: { children: React.ReactNode }) => (
  <li className="before:content-['*'] before:-mr-2 before:relative before:-left-4 pl-6">
    {children}
  </li>
);

export const UnderLine = ({ color = '#FFC118' }: { color?: string }) => (
  <div className="absolute left-0 bottom-0 w-full mt-[-6px]">
    <svg
      className="mx-auto"
      width="90%"
      viewBox="0 0 613 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M528.625 5.544L524.222 5.148C538.24 4.86 544.799 5.256 556.75 4.824L556.121 4.932C557.918 5.004 558.727 4.032 578.226 5.112C578.855 5.112 578.855 5.04 580.202 5.148L576.788 4.896C578.765 4.788 580.472 4.536 583.168 4.5C583.707 4.536 583.976 4.644 584.066 4.716L590.626 4.608L592.692 4.86C594.669 4.68 593.681 4.104 599.072 4.392C597.006 3.996 601.678 4.14 600.959 3.924C601.229 3.96 601.858 4.032 602.397 4.104C605.542 4.032 611.562 3.888 613 3.672C613 3.672 600.42 2.88 597.006 2.484C601.498 2.556 598.174 2.412 597.275 2.304L597.006 2.412C594.31 2.34 594.22 2.052 592.872 2.016C592.872 2.016 592.872 2.052 592.962 2.088H593.142C593.321 2.088 593.142 2.124 593.142 2.16C593.142 2.232 593.142 2.268 592.333 2.232H592.423C591.345 2.232 589.368 2.232 588.559 2.232V2.016C586.582 2.448 575.081 1.476 572.385 1.476C569.689 1.224 566.365 1.584 563.04 1.476C557.738 1.476 560.344 1.188 557.648 1.008C554.324 0.9 558.367 1.26 557.02 1.296L552.976 1.008C555.312 0.972 554.054 0.828 553.605 0.756C550.101 0.756 544.619 0.396 543.631 0.828C538.958 0.648 538.868 0.468 536.892 0.468C537.611 0.54 538.958 0.612 538.958 0.684C537.071 0.504 538.06 0.72 538.869 0.792C536.083 1.008 523.952 0.108 523.413 0.576V0.504C522.784 0.864 523.952 1.188 521.976 1.404L520.628 1.26L518.651 1.44C517.303 1.332 517.932 1.224 517.932 1.188C514.697 1.368 510.114 1.188 506.161 1.188L510.564 2.124C507.149 1.908 501.129 1.512 500.5 1.836L498.433 1.512C491.604 0.936 493.85 1.8 491.155 1.656L487.74 1.332H491.065C487.65 1.152 486.303 1.044 483.607 0.828C483.787 0.828 483.876 0.828 483.966 0.864H483.517C483.158 1.044 481.45 1.188 479.114 1.188C475.789 1.188 473.184 1.44 467.792 1.116L466.534 1.476L462.491 1.296V1.008C466.354 1.008 473.723 0.828 478.755 0.792V0.648C475.789 0.648 472.465 0.828 470.488 0.792C469.499 0.756 466.983 0.468 468.781 0.252L466.983 0.54C457.009 0.648 456.919 0.648 446.496 0.396L447.395 0.54C445.328 0.648 443.261 0.72 442.722 0.54C436.432 0.54 429.963 0.396 425.829 0.072L425.021 0.432C423.673 0.432 421.606 -0.072 421.067 0.432L418.281 0.612C416.484 0.612 415.406 0.792 413.339 0.612C413.249 0.612 413.07 0.612 412.98 0.576C408.846 0.468 413.07 0.864 408.397 0.72C406.87 0.504 406.78 1.152 404.533 1.116L402.197 0.648C397.974 0.396 397.435 0.9 391.414 0.936C388.539 0.792 387.011 0.36 388.898 0C386.382 0.468 387.73 0.288 384.316 0.54C383.776 0.36 384.136 0.324 384.855 0.144C381.71 -0.036 382.968 0.324 380.631 0.324C380.002 0.684 379.373 1.224 378.565 1.26L379.463 1.368C377.037 1.584 374.342 1.692 371.466 1.512V1.332L368.501 1.44L368.231 1.224L363.918 1.332L364.547 1.404C363.559 1.44 360.234 1.548 358.257 1.404V1.296C352.866 0.936 348.463 1.476 342.173 1.584L342.982 1.332C340.735 1.08 342.443 1.728 339.837 1.62L339.657 1.296C337.5 1.728 336.692 1.224 335.164 1.08L335.973 1.476L333.008 1.404C329.773 1.296 330.941 0.9 331.39 0.684L329.234 1.008L328.694 0.648C327.167 1.08 327.077 0.576 324.292 0.828C324.022 0.684 324.741 0.612 323.752 0.576L319.17 1.116L321.955 0.864L321.686 1.404C318.81 1.836 317.732 1.404 315.665 1.548L317.103 1.368C313.689 1.512 313.509 1.296 311.532 1.188C312.161 1.296 313.06 1.404 311.712 1.512C310.723 1.512 311.173 1.332 310.184 1.296C310.004 1.656 307.578 1.836 305.332 1.692C305.332 1.656 305.332 1.584 305.512 1.548C304.972 1.62 304.703 1.692 303.714 1.62L304.254 1.224L302.456 1.62C301.198 1.512 299.401 1.8 299.491 1.548L300.21 1.476H290.595L290.416 1.152C289.517 1.584 285.204 1.008 285.563 1.548C283.676 1.26 278.465 1.8 279.453 1.188C273.163 1.188 269.839 1.8 262.201 1.548C259.415 1.044 251.957 1.26 247.015 1.26C237.49 1.548 231.29 1.764 221.586 2.016C215.565 1.332 206.939 2.376 200.559 2.016L198.852 2.304C194.539 1.872 188.249 2.484 182.229 2.088C180.791 2.232 180.072 2.268 179.713 2.268C179.982 2.268 180.432 2.34 180.521 2.52C178.814 2.412 175.4 2.592 175.579 2.232H176.029C176.208 1.836 170.907 2.412 169.02 2.088L170.098 2.448H166.863C166.863 2.412 167.672 2.34 167.672 2.34C153.924 3.276 147.454 2.124 134.515 2.988C136.132 2.556 131.999 3.24 131.729 2.772C128.315 2.232 125.619 2.952 123.013 3.096C123.013 3.096 123.013 3.132 122.834 3.168H118.071C120.767 2.556 114.747 3.636 117.263 3.168C104.862 2.808 88.9578 3.384 74.6706 3.276L75.2996 3.42C71.7054 3.42 67.2125 3.636 64.427 3.42C61.6414 3.204 58.4965 3.852 57.4182 3.888C54.4529 4.176 51.6674 3.672 52.9254 3.708C49.6906 3.816 46.8152 4.356 42.3223 4.14C40.7049 3.672 30.2816 4.716 30.012 4.14C24.2612 3.852 18.9597 4.536 12.7596 4.212C12.7596 4.212 12.8495 4.176 13.0292 4.14L0 5.724L3.86382 7.56L15.006 9L44.2992 8.46L67.8415 8.892L124.9 8.316L128.854 7.884C140.176 8.532 154.463 7.596 166.594 8.028L166.773 7.668C170.188 7.632 170.008 7.848 170.817 7.92C202.446 7.632 234.974 6.912 263.549 7.164C266.334 7.38 274.691 7.164 276.847 7.416C286.013 6.912 295.807 6.84 305.062 6.84H304.703C304.703 6.876 309.016 6.768 309.016 6.768C309.196 6.768 309.196 6.84 309.016 6.876C313.868 6.516 321.686 6.768 327.796 6.876H327.437C362.66 6.732 395.188 5.832 430.142 6.12C446.496 6.588 465.186 5.652 483.876 6.012C487.381 6.336 524.941 5.832 528.265 5.616L528.625 5.544Z"
        fill={color}
      />
    </svg>
    <svg
      width="100%"
      viewBox="0 0 613 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M528.625 5.544L524.222 5.148C538.24 4.86 544.799 5.256 556.75 4.824L556.121 4.932C557.918 5.004 558.727 4.032 578.226 5.112C578.855 5.112 578.855 5.04 580.202 5.148L576.788 4.896C578.765 4.788 580.472 4.536 583.168 4.5C583.707 4.536 583.976 4.644 584.066 4.716L590.626 4.608L592.692 4.86C594.669 4.68 593.681 4.104 599.072 4.392C597.006 3.996 601.678 4.14 600.959 3.924C601.229 3.96 601.858 4.032 602.397 4.104C605.542 4.032 611.562 3.888 613 3.672C613 3.672 600.42 2.88 597.006 2.484C601.498 2.556 598.174 2.412 597.275 2.304L597.006 2.412C594.31 2.34 594.22 2.052 592.872 2.016C592.872 2.016 592.872 2.052 592.962 2.088H593.142C593.321 2.088 593.142 2.124 593.142 2.16C593.142 2.232 593.142 2.268 592.333 2.232H592.423C591.345 2.232 589.368 2.232 588.559 2.232V2.016C586.582 2.448 575.081 1.476 572.385 1.476C569.689 1.224 566.365 1.584 563.04 1.476C557.738 1.476 560.344 1.188 557.648 1.008C554.324 0.9 558.367 1.26 557.02 1.296L552.976 1.008C555.312 0.972 554.054 0.828 553.605 0.756C550.101 0.756 544.619 0.396 543.631 0.828C538.958 0.648 538.868 0.468 536.892 0.468C537.611 0.54 538.958 0.612 538.958 0.684C537.071 0.504 538.06 0.72 538.869 0.792C536.083 1.008 523.952 0.108 523.413 0.576V0.504C522.784 0.864 523.952 1.188 521.976 1.404L520.628 1.26L518.651 1.44C517.303 1.332 517.932 1.224 517.932 1.188C514.697 1.368 510.114 1.188 506.161 1.188L510.564 2.124C507.149 1.908 501.129 1.512 500.5 1.836L498.433 1.512C491.604 0.936 493.85 1.8 491.155 1.656L487.74 1.332H491.065C487.65 1.152 486.303 1.044 483.607 0.828C483.787 0.828 483.876 0.828 483.966 0.864H483.517C483.158 1.044 481.45 1.188 479.114 1.188C475.789 1.188 473.184 1.44 467.792 1.116L466.534 1.476L462.491 1.296V1.008C466.354 1.008 473.723 0.828 478.755 0.792V0.648C475.789 0.648 472.465 0.828 470.488 0.792C469.499 0.756 466.983 0.468 468.781 0.252L466.983 0.54C457.009 0.648 456.919 0.648 446.496 0.396L447.395 0.54C445.328 0.648 443.261 0.72 442.722 0.54C436.432 0.54 429.963 0.396 425.829 0.072L425.021 0.432C423.673 0.432 421.606 -0.072 421.067 0.432L418.281 0.612C416.484 0.612 415.406 0.792 413.339 0.612C413.249 0.612 413.07 0.612 412.98 0.576C408.846 0.468 413.07 0.864 408.397 0.72C406.87 0.504 406.78 1.152 404.533 1.116L402.197 0.648C397.974 0.396 397.435 0.9 391.414 0.936C388.539 0.792 387.011 0.36 388.898 0C386.382 0.468 387.73 0.288 384.316 0.54C383.776 0.36 384.136 0.324 384.855 0.144C381.71 -0.036 382.968 0.324 380.631 0.324C380.002 0.684 379.373 1.224 378.565 1.26L379.463 1.368C377.037 1.584 374.342 1.692 371.466 1.512V1.332L368.501 1.44L368.231 1.224L363.918 1.332L364.547 1.404C363.559 1.44 360.234 1.548 358.257 1.404V1.296C352.866 0.936 348.463 1.476 342.173 1.584L342.982 1.332C340.735 1.08 342.443 1.728 339.837 1.62L339.657 1.296C337.5 1.728 336.692 1.224 335.164 1.08L335.973 1.476L333.008 1.404C329.773 1.296 330.941 0.9 331.39 0.684L329.234 1.008L328.694 0.648C327.167 1.08 327.077 0.576 324.292 0.828C324.022 0.684 324.741 0.612 323.752 0.576L319.17 1.116L321.955 0.864L321.686 1.404C318.81 1.836 317.732 1.404 315.665 1.548L317.103 1.368C313.689 1.512 313.509 1.296 311.532 1.188C312.161 1.296 313.06 1.404 311.712 1.512C310.723 1.512 311.173 1.332 310.184 1.296C310.004 1.656 307.578 1.836 305.332 1.692C305.332 1.656 305.332 1.584 305.512 1.548C304.972 1.62 304.703 1.692 303.714 1.62L304.254 1.224L302.456 1.62C301.198 1.512 299.401 1.8 299.491 1.548L300.21 1.476H290.595L290.416 1.152C289.517 1.584 285.204 1.008 285.563 1.548C283.676 1.26 278.465 1.8 279.453 1.188C273.163 1.188 269.839 1.8 262.201 1.548C259.415 1.044 251.957 1.26 247.015 1.26C237.49 1.548 231.29 1.764 221.586 2.016C215.565 1.332 206.939 2.376 200.559 2.016L198.852 2.304C194.539 1.872 188.249 2.484 182.229 2.088C180.791 2.232 180.072 2.268 179.713 2.268C179.982 2.268 180.432 2.34 180.521 2.52C178.814 2.412 175.4 2.592 175.579 2.232H176.029C176.208 1.836 170.907 2.412 169.02 2.088L170.098 2.448H166.863C166.863 2.412 167.672 2.34 167.672 2.34C153.924 3.276 147.454 2.124 134.515 2.988C136.132 2.556 131.999 3.24 131.729 2.772C128.315 2.232 125.619 2.952 123.013 3.096C123.013 3.096 123.013 3.132 122.834 3.168H118.071C120.767 2.556 114.747 3.636 117.263 3.168C104.862 2.808 88.9578 3.384 74.6706 3.276L75.2996 3.42C71.7054 3.42 67.2125 3.636 64.427 3.42C61.6414 3.204 58.4965 3.852 57.4182 3.888C54.4529 4.176 51.6674 3.672 52.9254 3.708C49.6906 3.816 46.8152 4.356 42.3223 4.14C40.7049 3.672 30.2816 4.716 30.012 4.14C24.2612 3.852 18.9597 4.536 12.7596 4.212C12.7596 4.212 12.8495 4.176 13.0292 4.14L0 5.724L3.86382 7.56L15.006 9L44.2992 8.46L67.8415 8.892L124.9 8.316L128.854 7.884C140.176 8.532 154.463 7.596 166.594 8.028L166.773 7.668C170.188 7.632 170.008 7.848 170.817 7.92C202.446 7.632 234.974 6.912 263.549 7.164C266.334 7.38 274.691 7.164 276.847 7.416C286.013 6.912 295.807 6.84 305.062 6.84H304.703C304.703 6.876 309.016 6.768 309.016 6.768C309.196 6.768 309.196 6.84 309.016 6.876C313.868 6.516 321.686 6.768 327.796 6.876H327.437C362.66 6.732 395.188 5.832 430.142 6.12C446.496 6.588 465.186 5.652 483.876 6.012C487.381 6.336 524.941 5.832 528.265 5.616L528.625 5.544Z"
        fill={color}
      />
    </svg>
  </div>
);
